import { render, staticRenderFns } from "./imageUpload.vue?vue&type=template&id=6c50d816&scoped=true"
import script from "./imageUpload.vue?vue&type=script&lang=js"
export * from "./imageUpload.vue?vue&type=script&lang=js"
import style0 from "./imageUpload.vue?vue&type=style&index=0&id=6c50d816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c50d816",
  null
  
)

export default component.exports